// TODO: Remove this after a while, once we see we don't use it anymore
import type { IValidationField } from 'hooks/useValidations/types';
import { t } from 'i18next';
import type { IGenericObject } from 'types';
import * as yup from 'yup';

import paymentDueDate from '../paymentDueDate';

export default function cropPaymentTerms({
  label = '',
  context: fieldContext = {},
}: IValidationField) {
  const { labels } = fieldContext;
  const paymentDueLabel = labels?.paymentDue || '';

  return yup
    .object()
    .shape({
      paymentTermsCode: yup
        .string()
        .label(label)
        .test({
          name: 'required_payment_terms',
          test: (name, context) => {
            const {
              options: { from },
              path,
            } = context as IGenericObject;

            const [
              { value: { paymentTermsCode = '' } = {} } = {},
              { value: { debtOwner = 'false' } = {} } = {},
            ] = from;

            if (debtOwner === 'false' && !paymentTermsCode) {
              return context.createError({
                message: t('errors.required', {
                  label,
                }),
                path,
              });
            }
            return true;
          },
        })
        .nullable()
        .default(''),
      paymentDueDate: paymentDueDate({ label: paymentDueLabel, type: 'paymentDueDate' }),
    })
    .default({});
}
